const SKOR_COLORS = [
    "gray",
    "green",
    "teal",
    "blue",
    "indigo",
    "purple",
    "pink",
    "red",
    "orange",
    "yellow",
  ];
export default {
    SKOR_COLORS : SKOR_COLORS
}